/* src/app/home/trailer-request/request-progress/request-progress.component.scss */
.row {
  max-width: 360px;
}
.peak-season {
  margin-bottom: 48px;
  line-height: 17px;
}
.move-up {
  margin-top: -20px;
}
.col.small {
  font-size: 80%;
}
@media (min-width: 1280px) {
  .row {
    max-width: 408px;
  }
}
/*# sourceMappingURL=request-progress.component.css.map */
